import { memo, useEffect } from 'react'
import { useMessageListScrollActions } from '../../message-list/scroll-atoms'

export const ScrollShortcutHandler = memo(() => {
  const { scrollToEnd, scrollToStart } = useMessageListScrollActions()

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.ctrlKey || e.metaKey) && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        const active = document.activeElement
        const isTextInput =
          active instanceof HTMLTextAreaElement ||
          active instanceof HTMLInputElement ||
          active?.getAttribute('contenteditable') === 'true'
        if (isTextInput) return

        e.preventDefault()
        if (e.key === 'ArrowDown') {
          scrollToEnd()
        } else {
          scrollToStart()
        }
      }
    }
    addEventListener('keydown', handleKeyDown)
    return () => removeEventListener('keydown', handleKeyDown)
  }, [scrollToEnd, scrollToStart])

  return null
})
ScrollShortcutHandler.displayName = 'ScrollShortcutHandler'
